import React from 'react';
import { registerHook, unregisterHook, isClickTo } from "../../store/clickWrapper";
import { generate as generateReportLinks, renderLink } from '../common/reportLinks';
import { popupActions } from '../../store/popupStore';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getModeClasses } from './modeClassesResolver';
import { withLocalize } from 'react-localize-redux';
import { isFunction, isNullOrUndefined } from '../../store/storeFunctions';

class ReportButtons extends React.Component {

    items = undefined;
    opener = undefined;
    openerRect = undefined;
    mounted = false;
    buttons = {};

    constructor(props) {
        super(props);
        this.state = {
            moreBtnOpen: false,
            btnOffsets: null,
            visibleLinks: [],
            invisibleLinks: [],
            oldWidth: props.maxTableWidth,
            allLinks: generateReportLinks(props.entityInfo.entityId, props.entityInfo.reports,
                false, false, props.entityInfo.type === 2 ? 2 : props.entityInfo.entrepreneur === true ? 3 : 1),
        }
    }

    componentDidMount() {
        this.mounted = true;
        this.hookId = registerHook(this, (click) => {
            if (this.state.moreBtnOpen && !isClickTo(click, [this.opener, this.items]) && this.mounted) {
                this.setState({ moreBtnOpen: false });
                this.callOpenDropDown(false);
            }
        });
        this.setupButtonOffsets(this.props.maxTableWidth);
        const that = this;
        this.updaterInterval = window.setInterval(function () { that.setupButtonOffsets(that.props.maxTableWidth); }, 500);

    }

    componentDidUpdate(preState) {
        if (this.props.maxTableWidth !== preState.maxTableWidth) {
            this.setupButtonOffsets(this.props.maxTableWidth);
            this.setState({ maxTableWidth: this.props.maxTableWidth });
        }
    }

    componentWillUnmount() {
        this.mounted = false;
        unregisterHook(this.hookId);
        window.clearInterval(this.updaterInterval);
    }

    render() {
        const style = this.props.style;
        const mode = this.props.mode;

        return (
            <div className={classnames('report-links-container', mode ? getModeClasses(mode.buttons) : {})} style={style} >
                <span style={{ display: 'flex', width: '100%' }}>
                    <span
                        className="report-links"
                        onMouseDown={(e) => e.stopPropagation()} onMouseUp={(e) => e.stopPropagation()}
                    >
                        {this.state.visibleLinks.map(link =>
                            <span
                                key={link.translationKey}
                                ref={el => this.syncButtonDims(link.translationKey, el)}>
                                {renderLink(link.url, link.translationKey, false, link.primaryAttr, true,
                                    this.props.translate, '', this.props.useShort, null, link.type, this.props
                                )}
                            </span>
                        )}
                    </span>
                    {this.state.invisibleLinks.length > 0 &&
                        <div
                            className={classnames({ 'dropdown is-right': true, 'is-active': this.state.moreBtnOpen })}
                            style={{ margin: "auto 0 auto auto" }}
                        >
                            <div
                                className="dropdown-trigger" ref={(el) => this.syncOpenerDims(el)}
                                style={{ width: '1cm', textAlign: 'right', cursor: "pointer" }}
                                onClick={e => {
                                    let beforeState = this.state;
                                    e.stopPropagation();
                                    this.setState({ moreBtnOpen: !this.state.moreBtnOpen });
                                    this.callOpenDropDown(!beforeState.moreBtnOpen);
                                }}
                                onMouseDown={(e) => e.stopPropagation()} onMouseUp={(e) => e.stopPropagation()}
                            >
                                <FontAwesomeIcon icon="ellipsis-v" style={{ margin: "auto", width: '1em', height: '1em' }} />
                            </div>
                            <div className="dropdown-menu" ref={(el) => this.items = el} role="menu">
                                <div
                                    className="dropdown-content"
                                    onMouseDown={e => e.stopPropagation()} onMouseUp={e => e.stopPropagation()}
                                >
                                    <span className="report-links">
                                        {this.state.invisibleLinks.map(link =>
                                            <div key={link.translationKey} className="dropdown-item" style={{ whiteSpace: 'nowrap' }}>
                                                {renderLink(
                                                    link.url, link.translationKey, false,
                                                    link.primaryAttr, false, this.props.translate, '', this.props.useShort, null, link.type, this.props
                                                )}
                                            </div>
                                        )}
                                    </span>
                                </div>
                            </div>
                        </div>
                    }
                </span>
            </div>
        );
    }

    callOpenDropDown(value) {
        if (isFunction(this.props.openDropDown))
            this.props.openDropDown(value);
    }

    syncOpenerDims = (element) => {
        this.opener = element;
        if (element === null || element === undefined) {
            return;
        }
        const elRect = element.getBoundingClientRect();
        if (this.openerRect === null || this.openerRect === undefined) {
            this.openerRect = elRect;
            return;
        }
        if (elRect.width !== 0 && this.openerRect.width !== elRect.width) {
            this.openerRect = elRect;
        }
    }

    syncButtonDims = (key, element) => {
        if (element === null || element === undefined) {
            return;
        }
        const elRect = element.getBoundingClientRect();
        if (this.buttons[key] === null || this.buttons[key] === undefined) {
            this.buttons[key] = elRect;
            return;
        }
        const rect = this.buttons[key];
        if (elRect.width !== 0 && rect.width !== elRect.width) {
            this.buttons[key] = elRect;
        }
    }

    setupButtonOffsets = (maxWidth) => {
        const all = [...this.state.allLinks];
        let newVisible = [];
        let newHidden = [];
        if (localStorage.getItem('locales_report_buttons_format') === 'short') {
            newVisible = all;
        } else if (!isNullOrUndefined(this.props.visibleButtonCount)) {
            var visibleButtonCount = this.props.visibleButtonCount;
            visibleButtonCount = all.length < visibleButtonCount ? all.length : visibleButtonCount;
            newVisible = all.slice(0, visibleButtonCount);
            newHidden = all.slice(visibleButtonCount);
        }
        else {
            newVisible = all;
        }

        if (maxWidth === undefined || maxWidth === 0) {
            this.setState({ visibleLinks: newVisible, invisibleLinks: newHidden });
            return;
        }
        const btnWidthSum = Object.keys(this.buttons).map(b => this.buttons[b].width).reduce((a, b) => a + b, 0);
        if (btnWidthSum === 0 || maxWidth < 0 || maxWidth > btnWidthSum) {
            this.setState({ visibleLinks: newVisible, invisibleLinks: newHidden });
            return;
        }

        if (localStorage.getItem('locales_report_buttons_format') === 'short' || isNullOrUndefined(this.props.visibleButtonCount)) {
            newVisible = [];
            newHidden = [];
            let currentW = (this.openerRect || {}).width || 0;
            for (let i = 0; i < all.length; i++) {
                const box = this.buttons[all[i].translationKey].width;
                if ((currentW + box < maxWidth)) {
                    newVisible.push(all[i])
                    currentW = currentW + box;
                } else {
                    newHidden.push(all[i]);
                }
            }

            this.setState({ visibleLinks: newVisible, invisibleLinks: newHidden });
        } else {
            if (this.state.visibleLinks.length !== newVisible.length || this.state.invisibleLinks.length !== newHidden.length) {
                this.setState({ visibleLinks: newVisible, invisibleLinks: newHidden });
            }
        }

        return;
    }
}

export default withLocalize(withRouter(connect(
    state => ({ ...state.layout }),
    dispatch => bindActionCreators({ ...popupActions }, dispatch),
)(ReportButtons)));